  export const setAttachmentLibraryData = (value) => {
    return {
      type: "SET_ATTACHMENT_LIBRARY_DATA",
      payload: { data: value },
    };
  };
  export const setAttachmentLibraryDataCount = (value) => {
    return {
      type: "SET_ATTACHMENT_LIBRARY_DATA_COUNT",
      payload: { data: value },
    };
  };
  export const setSelectedVideo = (value) => {
    return {
      type: "SET_SELECTED_VIDEO",
      payload: { data: value },
    };
  };

export const setAttachmentPagination = (pagination) => {
 return {
    type: "SET_ATTACHMENT_PAGINATION",
    payload: { data: pagination },
  };
}